import type { SVGProps } from "react";

export default function AuditIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.33268 18.3333C5.18998 18.3333 3.61864 18.3333 2.64232 17.357C1.66602 16.3807 1.66602 15.6427 1.66602 12.5"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M18.3327 12.5C18.3327 15.6427 18.3327 16.3807 17.3563 17.357C16.3801 18.3333 14.8087 18.3333 11.666 18.3333"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M11.666 1.66797C14.8087 1.66797 16.3801 1.66797 17.3563 2.64428C18.3327 3.62059 18.3327 4.3586 18.3327 7.5013"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M8.33268 1.66797C5.18998 1.66797 3.61864 1.66797 2.64232 2.64428C1.66602 3.62059 1.66602 4.3586 1.66602 7.5013"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M1.66602 10H18.3327"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
